<template>
  <div
    class="comment-container"
    :class="{
      'right-side': isRightAligned,
      [userClass]: true
    }"
  >
    <div class="comment-wrapper">
      <div class="comment-header">
        <div
          :style="{ order: isRightAligned ? 2 : 1 }"
          :class="{ 'text-right': isRightAligned, 'text-left': !isRightAligned }"
        >
          <p v-if="comment.user_id === agentId" class="user-type">
            Agente
          </p>
          <p v-else-if="comment.user_id === userId" class="user-type">
            Solicitante
          </p>
          <p v-else-if="followersIds.includes(comment.user_id)" class="user-type">
            Seguidor
          </p>
          <p v-else class="user-type">
            Externo
          </p>
          <p class="mb-0 user-name">{{ comment.user | concatName2 | titleize }}</p>
        </div>
        <div class="d-flex align-items-center" :style="{ order: isRightAligned ? 1 : 2 }">
          <p class="mb-0 text-right timestamp">
            {{ comment.created_at | formatDateTime }}
          </p>
        </div>
      </div>
      <div class="comment-content">
        <LinkifiedText
          tag="pre"
          :text="comment.content"
          class="comment-pre"
        />

        <hr v-if="attachmentType" class="my-1">
        <div v-if="attachmentType" class="attachment">
          <b-link @click="handleOnClickAttachment" style="max-width: 99%; overflow: hidden; text-overflow: ellipsis;">
            <span v-if="attachmentType == 'document'">
              <font-awesome-icon :icon="['far', 'file-alt']" fixed-width />
              <span>{{ comment.document.name }}</span>
            </span>
            <span v-else>
              <font-awesome-icon :icon="['far', 'image']" fixed-width />
              <span>{{ comment.photo.caption }}</span>
            </span>
          </b-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LinkifiedText from '../../shared/LinkifiedText.vue'

export default {
  name: 'Comment',
  props: {
    comment: { type: Object, required: true },
    agentId: { type: Number, required: true },
    userId: { type: Number, required: true },
    followersIds: { type: Array, required: true }
  },
  components: { LinkifiedText },
  data () {
    return {
      processing: false
    }
  },
  computed: {
    userClass () {
      if (this.agentId === this.comment.user.id) {
        return 'agent-message'
      } else if (this.userId === this.comment.user.id) {
        return 'user-message'
      }

      return 'other-message'
    },
    isRightAligned () {
      if (this.comment.user_id === this.agentId) return true

      return false
    },
    attachmentType () {
      if (this.comment?.document?.id) return 'document'
      if (this.comment?.photo?.id) return 'image'

      return false
    }
  },
  methods: {
    handleOnClickAttachment () {
      if (this.processing) { return }
      this.processing = true

      if (this.comment?.photo?.id) {
        this.$http.get(`/api/production/internal_tickets/${this.comment.internal_ticket_id}/internal_ticket_notes/${this.comment.id}/photos/${this.comment.photo.id}`)
          .then((resp) => {
            this.$emit('showFullImage', resp.data.presigned_url)
          })
          .catch(e => console.log(e))
          .finally(() => this.processing = false)
      } else {
        this.$http.get(`/api/production/internal_tickets/${this.comment.internal_ticket_id}/internal_ticket_notes/${this.comment.id}/documents/${this.comment.document.id}/download`)
          .then((resp) => {
            const url = resp.data
            const link = document.createElement('a')
            link.href = url
            link.download = this.comment.document.name
            document.body.appendChild(link)
            link.click()
            link.remove()
          })
          .catch(e => console.log(e))
          .finally(this.processing = false)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.comment-container {
  display: flex;
  margin-bottom: 12px;
  width: 100%;
  position: relative;

  .attachment {
    margin-top: 10px;
    display: flex;
    align-items: center;
    font-size: 0.9rem;

    span {
      font-style: italic;
    }
  }

  &.right-side {
    justify-content: flex-end;

    .comment-wrapper {
      background-color: #d0e6ff;
      border-top-right-radius: 4px;
      border-top-left-radius: 16px;
    }

    .comment-wrapper::after {
      content: "";
      position: absolute;
      right: -10px;
      top: 8px;
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-left: 10px solid #d0e6ff;
    }
  }

  &:not(.right-side) {
    justify-content: flex-start;

    .comment-wrapper {
      border-top-left-radius: 4px;
      border-top-right-radius: 16px;

      .comment-content .comment-pre {
        text-align: left;
      }
    }

    .comment-wrapper::after {
      content: "";
      position: absolute;
      left: -10px;
      top: 8px;
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-right: 10px solid transparent;
    }

    &.agent-message .comment-wrapper {
      background-color: #defcf2;
      &::after {
        border-right-color: #defcf2;
      }
    }

    &.user-message .comment-wrapper {
      background-color: #fff3d4;
      &::after {
        border-right-color: #fff3d4;
      }
    }

    &.other-message .comment-wrapper {
      background-color: #f2eeee;
      &::after {
        border-right-color: #f2eeee;
      }
    }
  }

  .comment-wrapper {
    width: 90%;
    border-radius: 16px;
    padding: 10px 14px;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
  }

  .comment-header {
    display: flex;
    width: 100%;
    justify-content: space-between;
    font-size: 16px;
    color: #5f5c5c;
    margin-bottom: 7px;

    .user-name {
      font-weight: 500;
    }

    .timestamp {
      font-size: 14px;
      color: #868282;
    }

    .user-type {
      font-style: italic;
      font-size: 11px;
      color: #868282;
      margin-bottom: 0;
      line-height: 10px;
    }
  }

  .comment-content .comment-pre {
    white-space: pre-line;
    font-size: 1.1rem;
    color: #222;
    margin: 0;
    font-family: 'Segoe UI', sans-serif;
    text-align: left !important;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
}
</style>
